export function isRefactorPrescription(numberText) {
  if (numberText === undefined) {
    return false;
  }

  return numberText.charAt(0) === "R";
}
